import { Fragment, useContext, useEffect, useRef, useState } from "react";
import React from "react";
import { InstantSearch, Configure, useInfiniteHits, useInstantSearch, HierarchicalMenu } from "react-instantsearch";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { decodeFilters, isValidArray, normalizePath } from "../../Layout/Common/common";
import { SelectedFilterMobileLite } from "../algolia/selectedFilterMobile";
import { SelectedFilterLite } from "../algolia/selectedFilter";
import { FacetFilterLite } from "../algolia/facetFilter";
import { SoryByOption } from "../algolia/sortbyOption";
import { FilterContainerMobileLite } from "../algolia/filterContainerMobile";
import { SoryByOptionMobile } from "../algolia/sortbyOptionMobile";
import { SearchResultContainer } from "./searchResutlContainer";
import { axiosInstance } from "../../axios/axiosInstance";
import { CustomHierarchicalMenu } from "../algolia/customHierarchicalMenu";
import { CategoryHtmlBlog } from "./categoryHtmlBlog";
import { SubCategoryGrid } from "./subCategoryGrid";
import { GlobalContext } from "../../Context/GlobalContext";
import { CustomInfiniteHitsLite } from "../algolia/customInfiniteHits";
import { useLocation } from "react-router-dom";
import { ProductCardPopularProduct } from "../../Layout/Common/productCardPopularProduct";
import { useDevice } from "../../Context/hook/useDeviceType";
import {
  ApplyDisjunctiveFiltersFromUrl,
  getInitialSortByUiState,
  indexName,
  LATEST_SORTBY_VALUE,
  MAX_FACET_VALUES,
  searchClient,
  SORTBY_OPTION,
  UseCaptureFacets,
} from "../../Layout/Common/algoliaInstantLib";
import { ChangeViewOfProducts } from "./changeViewOfProducts";
import { SearchResultItems } from "../algolia/searchResultItems";
import ShowWhenHasResults from "../algolia/algoliaResultHandler";
import { usePageTitle } from "../../utils/pageTitle";

export const AlgoliaCategoryMain = () => {
  const { categoryDataAll, isGridView, historyRef } = useContext(GlobalContext);
  const { device } = useDevice();
  const [sideFilterClicked, setSideFilterClicked] = useState(false);
  const [facetFilters, setFacetFilters] = useState(null);
  const [breadCrumb, setBreadCrumb] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [htmlBlog, setHtmlBlog] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const categoryRef = useRef();
  const location = useLocation();
  const [mainCategory, setmainCategory] = useState("");
  const [subCategoryList, setSubCategoryList] = useState(null);
  const [showOtherFilters, setShowOtherFilters] = useState(false);
  const [categoryMenuItems, setCategoryMenuItems] = useState(null);
  usePageTitle(categoryName);

  useEffect(() => {
    setFacetFilters([]);
    setIsLoading(true);
    if (!isValidArray(categoryDataAll)) {
      fetchFacet();
    } else {
      var catDetail = categoryDataAll.find(
        (ct) => String(ct.url).replace(/^\/|\/$/g, "") == location.pathname.replace(/^\/|\/$/g, ""),
      );
      if (catDetail) {
        var currUrl = catDetail.url;
        let initialData = catDetail.eaPath;
        var arrayObject = initialData.split(" > ");
        setmainCategory(catDetail.url);
        setCategoryFilter(initialData);
        setCategoryName(catDetail.categoryName);
        renderBreadcrumb(arrayObject, currUrl);
        loadCategoryContent(catDetail.categoryId);
        if (isValidArray(arrayObject) && arrayObject.length > 1) {
          setShowOtherFilters(true);
        } else setShowOtherFilters(false);
      } else {
        fetchFacet();
      }
    }
    //loadSubcategorydata();
  }, [location.pathname]);

  const loadSubcategorydata = async () => {
    const res = await axiosInstance.post("CategoryPage/GetSubCategory", {
      catUrl: location.pathname,
    });
    setSubCategoryList(res.data);
  };
  useEffect(() => {
    if (device && device == "desktop") {
      setSideFilterClicked(true);
    } else {
      setSideFilterClicked(false);
    }
  }, [device]);

  async function fetchFacet() {
    const res = await axiosInstance.post("CategoryPage/GetCategoryBreadCurmb", {
      eapath: location.pathname,
    });
    if (res.data) {
      var catFilter = res.data.categoryFilter || {};
      var currUrl = res.data.url || location.pathname || "";
      let arrayObject = Object.values(catFilter).filter(Boolean);
      setmainCategory(currUrl);
      let initialData = arrayObject.join(" > ");
      setCategoryFilter(initialData);
      setCategoryName(res.data.catgoryName || "");
      renderBreadcrumb(arrayObject, currUrl);
      loadCategoryContent(res.data.categoryId);
      setShowOtherFilters(isValidArray(arrayObject) && arrayObject.length > 1);
    }
    setIsLoading(false);
  }
  const renderBreadcrumb = (textArr, url) => {
    const safeTextArr = Array.isArray(textArr) ? textArr.filter(Boolean) : [];
    const safeUrl = typeof url === "string" ? url : location.pathname || "";

    let urlArr = safeUrl
      .split("/")
      .filter(Boolean)
      .filter((u) => u != "pl");

    if (!safeTextArr.length) {
      setBreadCrumb([]);
      return;
    }

    const firstTextSlug = String(safeTextArr[0]).toLowerCase().replace(/\s+/g, "-");
    const lastUrlPart = urlArr[urlArr.length - 1] || "";
    const isReversed = firstTextSlug ? normalizePath(lastUrlPart) === normalizePath(firstTextSlug) : false;
    if (isReversed) urlArr = urlArr.reverse();

    const breadcrumbs = safeTextArr.map((label, index) => ({
      name: label,
      url: "/" + urlArr.slice(0, index + 1).join("/") + "/",
    }));
    setBreadCrumb(breadcrumbs);
  };

  const loadCategoryContent = async (catId) => {
    const res = await axiosInstance.post("CategoryPage/GetCategoryBlogContent", {
      categoryId: catId,
    });
    if (res.data) {
      setHtmlBlog(res.data);
    } else {
      setHtmlBlog(null);
    }
  };

  const categoryRefine = (val) => {
    if (categoryRef.current) {
      categoryRef.current.categoryRefine(val);
    }
  };

  return (
    <Fragment>
      <BreadCrumb data={breadCrumb} />

      <Fragment>
        <InstantSearch
          key={location.pathname}
          searchClient={searchClient}
          indexName={indexName}
          initialUiState={
            location.pathname.includes("/new-products")
              ? { [indexName]: { sortBy: LATEST_SORTBY_VALUE } }
              : getInitialSortByUiState(indexName)
          }
        >
          <CategoryConfigure />
          {categoryFilter && <PredefinedCategoryFilter defaultCategory={categoryFilter} />}
          {!isValidArray(facetFilters) && <UseCaptureFacets setFacets={setFacetFilters} />}
          {isValidArray(facetFilters) && <ApplyDisjunctiveFiltersFromUrl />}

          <section className="subcategory-section">
            <div className="container-fluid container-lg">
              <SearchResultContainer search={categoryName} isEbook={true} mainCategory={mainCategory} />
              <CategoryHtmlBlog html={htmlBlog} />
              <SubCategoryGrid subcategoryList={categoryMenuItems} />
            </div>
          </section>

          <section className="filter-popular-section pt-0">
            <div className="container-fluid container-lg">
              <div className="row">
                <div className="col-lg-12">
                  <div className="filterHead-wrapper filterHead-wrapperWeb">
                    <div className="filterbtn-left">
                      <button
                        className="btn"
                        id="searchFilter-btn"
                        onClick={() => setSideFilterClicked(!sideFilterClicked)}
                      >
                        <span className="wes-searchfilter" />
                        {sideFilterClicked ? "Hide Filters" : "Filter"}
                      </button>
                    </div>
                    <div className="filters-list">
                      <SoryByOption indexName={indexName} />
                      <ChangeViewOfProducts />
                    </div>
                  </div>
                  {device != "desktop" && (
                    <div className="filterHead-wrapper filterHead-wrapperMob d-flex">
                      <FilterContainerMobileLite filterItems={facetFilters} ref={categoryRef} />
                      <div className="d-flex justify-content-end gap-2 align-items-center">
                        <SoryByOptionMobile />
                        <ChangeViewOfProducts />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-12">
                  <div className={`filter-product-wrapper ${sideFilterClicked ? "" : "filter-product-wrapperHide"}`}>
                    <div className={`filter-wrapper filter-wrapperWeb  mt-3 ${sideFilterClicked ? "filtersWeb" : ""}`}>
                      <div className="accordion filters-accordion accordion-flush" id="selectedfilterAccordion">
                        {isValidArray(facetFilters) && <SelectedFilterLite categoryRefine={categoryRefine} />}
                      </div>
                      <div className="accordion filters-accordion accordion-flush" id="category-filter">
                        <CustomHierarchicalMenu ref={categoryRef} onItemsChange={setCategoryMenuItems} />
                      </div>
                      <div className="accordion filters-accordion accordion-flush" id="filterAccordion2">
                        <FacetFilterLite
                          attribute={`prodSpecs.manufacturer`}
                          limit={30}
                          showMore={true}
                          defaultOpenClass="show "
                        />
                      </div>
                      <div className="accordion filters-accordion accordion-flush mt-3" id="filterAccordion">
                        {showOtherFilters && isValidArray(facetFilters) ? (
                          <Fragment>
                            {facetFilters.map((Item, index) => (
                              <FacetFilterLite attribute={`prodSpecs.${Item}`} limit={30} showMore={true} />
                            ))}
                          </Fragment>
                        ) : (
                          showOtherFilters && <div className="accordion-item">loading..</div>
                        )}
                      </div>
                    </div>
                    <div
                      className={`ct-filter-product ${!sideFilterClicked ? "filterProducts" : "active"} ${
                        isGridView ? "" : "position-relative filterProducts"
                      }`}
                      style={{ width: "100%" }}
                    >
                      {isValidArray(facetFilters) && <SelectedFilterMobileLite />}

                      <div className={`row results-min-height ${isGridView ? "row-spacing row-equal" : ""}`}>
                        {/* <CustomInfiniteHitsLite catFilter={false} /> */}
                        <ShowWhenHasResults>
                          <SearchResultItems distinctFamilyMode={true} />
                        </ShowWhenHasResults>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </InstantSearch>
      </Fragment>
    </Fragment>
  );
};
function CategoryConfigure() {
  return <Configure hitsPerPage={50} maxValuesPerFacet={MAX_FACET_VALUES} distinct={false} />;
}

function PredefinedCategoryFilter({ defaultCategory }) {
  const { setIndexUiState } = useInstantSearch();

  useEffect(() => {
    if (defaultCategory) {
      setIndexUiState((prev) => ({
        ...prev,
        hierarchicalMenu: {
          ...prev.hierarchicalMenu,
          "categories.lvl0": [defaultCategory],
        },
        page: 0,
      }));
    }
  }, [defaultCategory, setIndexUiState]);

  return null;
}
